module.exports = __webpack_public_path__ + "img/max-person-configure.c4d9edb1.svg";